import { Radio } from 'antd';
import styled from 'styled-components';

/**
 * @deprecated use Radio from '@frontend/components' instead.
 */
const StyledRadio = styled(Radio)``;
StyledRadio.Group = styled(Radio.Group)``;

export default StyledRadio;
